import { render, staticRenderFns } from "./SuZhou.vue?vue&type=template&id=9864afba&scoped=true&"
import script from "./SuZhou.vue?vue&type=script&lang=js&"
export * from "./SuZhou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9864afba",
  null
  
)

export default component.exports